import { informacionBasicaTypes } from "../../types/informacionBasicaTypes"

export const savePadre = ( payload ) => ({
    type: informacionBasicaTypes.INFO_BASICA_SAVE_START,
    payload
})

export const validCodigoVerificacion = ( payload ) => ({
    type: informacionBasicaTypes.INFO_BASICA_VALIDATED,
    payload
})

export const updateInfoBasica = ( payload ) => ({
    type: informacionBasicaTypes.INFO_BASICA_UPDATED,
    payload
})
